import styled, { css } from 'styled-components';

export const Container = styled.div`
   position: relative;
   display: flex;
   width: 310px;
   height: 200px;
   flex-direction: column;
   padding: 0.3rem;
   border-radius: 10px;
   box-shadow: 0 1px 1px #ccc;
   background-color: ${({ isUserSystem }) => isUserSystem ? ' #E7F8FF' : '#ffffff'};
  
   iframe{
      height: 170px;
      border: none;
   }
   .footer-styled{
      margin-top: 0.5rem;
      ${({ isUserSystem }) =>
      !isUserSystem &&
      css`
            position: absolute;
            bottom: 6px;
            right: 10px;
         `
      }
   }

`